<template>
  <modal
    @close="
      $emit('close');
      $emit('reload');
    "
  >
    <template slot="header">
      Upload list (TXT/CSV file, one address per line) -
      <template v-if="form._id">edit</template>
      <template v-if="!form._id">add new</template>
    </template>
    <fieldset class="mb-3" :class="{ 'loading-mask': loading }">
      <div class="form-group row">
        <label class="col-form-label col-lg-2">List name</label>
        <div class="col-lg-4">
          <upload
            :onUploadCompleted="completed"
            :onUploadProgress="inprogress"
            :url="url"
            :multiple="false"
            :accept="''"
          />
        </div>
      </div>
      <div class="alert alert-danger" v-if="err">{{ err }}</div>
      <div class="alert alert-success" v-if="success">{{ success }}</div>
      <div class="form-group row">
        <label class="col-form-label col-lg-12">
          <button class="btn btn-link" @click="$emit('close')">Close</button>
        </label>
      </div>
    </fieldset>
  </modal>
</template>
<script>
import modal from "../common/Modal.vue";
import upload from "../common/FileUpload.vue";

export default {
  components: { modal, upload },
  props: {
    id: null,
    url: null,
  },
  data() {
    return {
      form: {
        title: null,
      },
      err: null,
      loading: false,
      success: null,
    };
  },
  methods: {
    completed(res, body) {
      if (body.data) {
        var d = body.data;
        this.success = `
                Lines found: ${d.lines_found}, Invalid addresses: ${d.invalid_addresses_count},
                Duplicated addresses: ${d.duplicated_addresses}, Valid addresses: ${d.valid_addresses}
                `;
      }
    },
    inprogress(res, body) {},
  },
  mounted() {
    if (typeof this.id !== "string") {
      return;
    }
  },
};
</script>


// WEBPACK FOOTER //
// src/components/modal/Upload.vue